import { cities } from "@api/geo/cities/api";
import { countries } from "@api/geo/countries/api";
import { currencies } from "@api/geo/currencies/api";
import { states } from "@api/geo/states/api";

export const geo = {
  currencies,
  countries,
  cities,
  states,
};
